/**
 * @Author : zhouqinze
 * @Date : 2019-12-29
 * @Version : 1.0
 * @Content : 职业发展
 **/
<template>
    <div>
        <div class="aboutComHead">
            <p>职业发展</p>
            <p><span></span><span></span></p>
        </div>
        <div class="growCon">
            <div class="growText">
                <h4>公司设置完整的培训模式：</h4>
                <p>新员工一对一培训+专业定期技术培训+外派学习培训+认证补贴+双阶梯职业发展通道+事业合伙人利润分享计划，提供技术与管理双通道职业规划。</p>
            </div>
            <div class="growText">
                <span>通易坚信，公司与员工的利益，情感，事业三个共同体趋于一致才能双赢，所以公司竭尽所能为员工提供明确的发展方向，清晰的奋斗目标以及足够的向上发展空间，与通易一起成长，一起收获。</span>
            </div>
            <div class="growText">
                <span>通易奉行不讲资历只讲能力的原则，建立完善的发展机制。对有重大或特殊贡献、持续考核成绩优秀之员工，可获破格晋升、不定期加薪、专业培训、优先职业规划等奖励。让每一个有能力优秀的你，都能找到适合自己的发展路径，获得与能力相匹配的回报与尊重。</span>
            </div>
            <div class="growText">
                <span>同时，公司还建立了学习型组织机制，员工可通过读书分享会、参加其他技能培训等途径，不断调整适合自己的职业定位，针对员工自学、考取适合公司业务需要的资格证书，给予奖学金奖励。 公司鼓励员工在工作中多学习多交流，共同成长。</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: .75rem;
        font-weight: bold;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .growCon{
        .growText{
            display: flex;
            text-align: left;
            color: #666;
            padding: 14px 0;
            h4{
                min-width: 14.375rem;
                font-size: 1.125rem;
                height: 2.5rem;
                line-height: 1.25rem;
            }
            p{
                font-size: 1rem;
                height: 2.5rem;
                line-height: 1.25rem;
                color: rgba(1,140,244,1)

            }
            span{
                font-size: 1rem;
                height: 2.5rem;
                line-height: 1.25rem;
            }
        }
    }
</style>